module.exports = __webpack_public_path__ + "img/changying_sm.d67dd2ca.png";